import { render, staticRenderFns } from "./NotificationsToolbarItem.vue?vue&type=template&id=e46194a6&scoped=true&"
import script from "./NotificationsToolbarItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationsToolbarItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsToolbarItem.vue?vue&type=style&index=0&id=e46194a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46194a6",
  null
  
)

export default component.exports